<template>
  <div id="zt599n">
    <div id="k1">
      <div>
        <label>ZT599N</label>
        <label v-if="iscn">按键压力:  1N～3N</label>
        <label v-else>Button pressure:  1N～3N</label>
        <span>
          <!-- <img :src="require('@/assets/pic/zt599n/icons.png')" /> -->
        </span>
      </div>
      <!-- <img :src="require('@/assets/pic/zt599n/bgcv1.png')" /> -->
    </div>
    <div id="k2">
      <img :src="require('@/assets/pic/keybicon.png')"/>
    </div>
    <div id="k3">
      <div v-if="iscn">符合标准</div>
      <div v-else>Compliances</div>
      <div>ISO,CE,RoHS</div>
    </div>
    <div id="k4">
      <div>{{$t('lang.prodsize')}}</div>
      <!-- <div>USB2.0 and RS-232 interfaces</div> -->
    </div>
    

    <pdspecs :data="iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  computed: {
    iscn () {
      return this.$store.state.iscn
    }
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    var _this = this
    return {
      asdata: [
        {
          label: 'ATM',
          pic: require('@/assets/pic/zt599n/as1.jpg')
        },
        {
          label: 'The ticket machine',
          pic: require('@/assets/pic/zt599n/as2.jpg')
        },
        {
          label: 'Self-service machine',
          pic: require('@/assets/pic/zt599n/as3.jpg')
        }
      ],
      spdata: {
        file: 'zt599n',
        data: [
          {label: '通讯接口', desc: ['USB2.0接口×1', 'PS/2接口（可选）'], pic: 'port.png'},
          {label: '输入电压', desc: ['DC5V±5%'], pic: 'char.png'},
          {label: '面板材料', desc: ['SUS304不锈钢'], pic: 'keymt.png'},
          {label: '按键字符', desc: ['采用高强度油墨制作', '可定制各种文字或符号'], pic: 'scchsize.png'},
          {label: '防护级别', desc: ['IP65(静态)/IP54（动态）'], pic: 'guard.png'},
          {label: '符合标准', desc: ['ISO/IEC 9995和GB/T 14081'],pic: 'stdok.png'},
          {label: '保护能力', desc: ['停电敏感数据可保存5年以上'], pic: 'prtab.png'},
          {label: '产品净重', desc: ['0.90kg'], pic: 'weight.png'},
          {label: '按键压力', desc: ['1N~3N'], pic: 'bpress.png'},
          {label: 'EFT', desc: ['能通过重复频率100KHz，', '电压1.0KV抗干扰测试'], pic: 'eft.png'},
          {label: 'ESD', desc: ['可承受接触放电±6KV', '空气放电±8KV的静电攻击'], pic: 'esd.png'},
          {label: '产品尺寸', desc: ['358mm×128mm×46.1mm'], pic: 'size.png'},
          {label: '输入键盘', desc: ['68个不锈钢按键'], pic: 'keyt.png'},
          {label: '适用环境', desc: ['工作温度：-25℃～+60℃', '存储温度：-40℃～+70℃', '相对湿度：10%～93% RH (无凝结露) '], pic: 'env.png'}
        ]
      },
      spdata_en: {
        file: 'zt599n',
        data: [
          {label: 'Port', desc: ['USB2.0×1', 'PS/2port（optional）'], pic: 'port.png'},
          {label: 'lnput voltage', desc: ['DC5V±5%'], pic: 'char.png'},
          {label: 'Compliances', desc: ['ISO,CE,RoHS'],pic: 'stdok.png'},
          {label: 'Protection ability', desc: ['Sensitive data can be kept for more than 7 years during power outage'],pic: 'prtab.png'},
          {label: 'Button pressure', desc: ['1N~3N'], pic: 'bpress.png'},
          {label: 'Dimension ', desc: ['358mm × 128mm × 46.1mm'], pic: 'size.png'},
          {label: 'Panel dimension ', desc: ['330mm ×100mm'], pic: 'psize.png'},
          {label: 'EFT', desc: ['Pass the anti-interference test with a repetition frequency of 100KHz and a voltage of 1.0KV'],pic: 'eft.png'},
          {label: 'ESD', desc: ['Withstand electrostatic attack of contact discharge ±6KV，air discharge ±8KV'],pic: 'esd.png'},
          {label: 'Environment', desc: ['Working temp: -25℃-+50℃', 'Storage temp: -25℃~+55℃', 'Relative humidity: 10%~93%RH(non-condensing)'], pic: 'env.png'}
        ]
      },
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt599n {
  background: black;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt599n/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding-top: .7rem;
}
#k1 div {
  display: inline-block;
  vertical-align: top;
  margin-top: 2.55rem;
  margin-left: 3.72rem;
  /* width: 4.138rem; */
  color: white;
}
#k1 label {
  display: block;
  font-size: .6rem;
  font-weight: bold;
}
#k1 label:nth-child(2) {
  font-size: .36rem !important;
  font-weight: 500 !important;
  margin-top: .05rem;
}


#k2 {
  background: #B5B5B5;
  text-align: center;
  height: 1.78rem;
  overflow: hidden;
  box-sizing: border-box;
  /* line-height: 1.78rem !important; */
}

#k2 img {
  margin: .55rem auto;
  /* height: .8rem; */
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt599n/bg2.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  text-align: center;
}
#k3 div:nth-child(1) {
  margin-top: .7rem;
  font-size: .6rem;
  font-weight: bold;
}
#k3 div:nth-child(2) {
  font-size: .3rem;
  font-weight: 500;
  margin: .15rem auto;
}

#k3 img {
  width: 2.7rem;
  height: 3.89;
  margin-left: 8.4rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt599n/bg3.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  text-align: center;
}
#k4 div:nth-child(1) {
  font-size: .6rem;
  font-weight: bold;
  color: #4D4D4D;
  width: 6rem;
  margin: .58rem auto;
}
#k4 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 500;
  color: #666666;
  width: 6.2rem;
  margin: -.45rem auto;
}


</style>
